import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as submitButtonActions from '../../../actions/submit/submitButtonActions';
import * as portalActions from '../../../actions/portal-contact/portalActions';
import {toastr} from 'react-redux-toastr';
import {injectIntl} from 'react-intl';
import {messages} from '../../common/Translations';
import WithResolvedPromises from "../../common/WithResolvedPromises";
import Placeholder from "../../Placeholder";
import PlaceholderError from "../../common/PlaceholderError";
import ArticleCategoryForm from "./ArticleCategoryForm";
import ReactSelectFormatter from "../../../services/ReactSelectFormatter";
import * as articleCategoryActions from "../../../actions/articleCategoryActions";


class ArticleCategoryFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.submit = this.submit.bind(this);
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [];
        if (this.isUpdate()) {
            actions.push(this.props.actions.getArticleCategory(this.props.match.params.id))
        }
        actions.push(this.props.actions.loadPortals());

        return actions;
    }

    componentDidMount() {
        if (!this.isUpdate()) {
            this.props.actions.resetArticleCategory()
        }
    }

    submit(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        if (this.isUpdate()) {
            this.props.actions.updateArticleCategory(formFields, formFields.id).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.articleCategoryUpdated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        } else {
            this.props.actions.saveArticleCategory(formFields).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.articleCategoryCreated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        }
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    redirect() {
        this.context.router.history.push('/kategorier/nyheder');
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions}
                                  errorComponent={PlaceholderError}>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">
                                    {
                                        this.isUpdate() ?
                                            this.props.intl.formatMessage(messages.articleCategoryUpdated) :
                                            this.props.intl.formatMessage(messages.articleCategoryCreate)
                                    }
                                </h1>
                                <ArticleCategoryForm
                                    initialValues={this.props.category}
                                    portals={ReactSelectFormatter.format(this.props.portals)}
                                    onSubmit={this.submit}
                                    isUpdate={this.isUpdate()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </WithResolvedPromises>
        );
    }
}

ArticleCategoryFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        portals: state.portals,
        category: state.articleCategory,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...submitButtonActions,
            ...portalActions,
            ...articleCategoryActions
        }, dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ArticleCategoryFormContainer));





// WEBPACK FOOTER //
// ./web/src/components/articles/category/ArticleCategoryFormContainer.jsx